import { Hammer } from "lucide-react";
import { GlobalAnimatedLayout } from "~/components/animation/GlobalAnimatedLayout";
import GlobalTextTitleH3 from "~/components/global/GlobalTextTitleH3";
import Separator from "~/components/global/Separator";

const portfolioLocations = [
  {
    id: 1,
    category: "Bangun Rumah",
    title: "Bangun Rumah Alaya Grande",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/bangun-rumah-di-bekasi-1-alaya-grande.webp",
    desc: "Pemilik proyek ini adalah Alaya Realty yang berlokasi di Jatiluhur, Kota Bekasi",
    location: "Jatiluhur, Bekasi",
    tahun: 2019,
  },
  {
    id: 2,
    category: "Renovasi",
    title: "Proyek Renovasi Rancamaya Gold Estate",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/bangun-rumah-di-bekasi-2-rancamayagold-estate.webp",
    desc: "Pemilik proyek ini adalah Alaya Realty yang berlokasi di Jatimakmur, Kota Bekasi",
    location: "Jatimakmur, Bekasi",
    tahun: 2022,
  },
  {
    id: 3,
    category: "Bangun Rumah",
    title: "Proyek Bangun Rumah Ambara",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/bangun-rumah-di-bekasi-3-ambara.webp",
    desc: "Pemilik proyek ini adalah Alaya Realty yang berlokasi di Jatimakmur, Kota Bekasi",
    location: "Jatimakmur, Bekasi",
    tahun: 2022,
  },
  {
    id: 4,
    category: "Bangun Rumah",
    title: "Proyek Bangun Rumah Allegra House",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/bangun-rumah-di-bekasi-4-allegra.webp",
    desc: "Pemilik proyek ini adalah Alaya Realty yang berlokasi di Jatiasih, Kota Bekasi",
    location: "Jatiasih, Bekasi",
    tahun: 2023,
  },
  {
    id: 5,
    category: "Renovasi",
    title: "Proyek Renovasi Rumah MGT",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/bangun-rumah-di-bekasi-5-MGT.webp",
    desc: "Proyek renovasi ini berlokasi di Perum. Mutiara Gading Timur, Kota Bekasi.",
    location: "Mustika Jaya, Bekasi",
    tahun: 2023,
  },
  {
    id: 6,
    category: "Bangun Rumah",
    title: "Proyek Bangun Rumah Royal Tulip",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/bangun-rumah-di-bekasi-6-royal-tulip.webp",
    desc: "Pemilik proyek ini adalah Royal Tulip Cibubur yang berlokasi di Jatiranggon, Kota Bekasi",
    location: "Jatiranggon, Bekasi",
    tahun: 2024,
  },
  {
    id: 7,
    category: "Bangun Rumah",
    title: "Proyek Bangun Rumah Scandinavian Jatisari",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/bangun-rumah-di-bekasi-7-jatisari.webp",
    desc: "Pemilik proyek ini adalah Alaya Realty yang berlokasi di Jatisari, Kota Bekasi",
    location: "Jatisari, Bekasi",
    tahun: 2024,
  },
];
export default function JasaBangunRumahDiBekasiSect5Portofolio() {
  return (
    <>
      <Separator />
      {/* MENGAPA KAMI */}
      <div className="flex flex-col lg:flex-row gap-5 lg:gap-20">
        {/* ============================
                  LEFT — STICKY TITLE
              ============================ */}
        <div className="lg:w-[35%] w-full">
          <div className="lg:sticky lg:top-32 lg:pt-10">
            <GlobalAnimatedLayout direction="bottom" threshold={0.2}>
              <GlobalTextTitleH3
                center
                title="Kerja Nyata"
                desc="Pengalaman panjang dalam menangani renovasi hingga pembangunan rumah baru membuat kami memahami setiap kebutuhan klien. Dengan tenaga ahli dan standar kerja profesional, kami menghasilkan hunian berkualitas yang dapat dipercaya dan tahan lama."
              />
            </GlobalAnimatedLayout>
          </div>
        </div>

        {/* ============================
                  RIGHT — MAIN CONTENT
              ============================ */}
        <div className="lg:w-[65%] w-full flex flex-col gap-6">
          <h2 className="pt-[2rem] text-2xl mb-6 font-semibold">
            PORTOFOLIO BANGUN RUMAH DAN RENOVASI RUMAH DI BEKASI DAN SEKITARNYA
          </h2>
          <p className="text-lg mb-6">
            Kami percaya bahwa setiap rumah memiliki cerita. Melalui portofolio
            ini, Anda dapat melihat bagaimana Arsinesia membantu klien
            mewujudkan rumah impian mereka, baik dengan membangun dari awal
            maupun melakukan renovasi untuk hunian yang lebih nyaman dan modern.
          </p>
          <div className="grid grid-cols-1 gap-5 w-full ">
            <div className="pt-[2rem] grid gap-6">
              {portfolioLocations.map((project) => (
                <div
                  key={project.id}
                  className={`rounded-xl overflow-hidden border shadow-lg bg-white ${
                    project.id === 7 ? "lg:hidden" : ""
                  }`}
                >
                  <div className="relative">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-[200px] lg:h-[400px] object-cover"
                    />
                    <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                      {project.tahun}
                    </span>
                    <span className="absolute top-2 right-2 bg-green-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                      {project.category}
                    </span>
                  </div>
                  <div className="p-4">
                    <h3 className="text-lg font-semibold mb-1">
                      {project.title}
                    </h3>
                    <p className="text-gray-600 text-sm mb-1 italic">
                      Tahun: {project.tahun}
                    </p>
                    <p className="text-gray-600 text-sm mb-3">{project.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
